import generateParseObject from "./common/parse/ParseObjectFactory";
import {toJSONList,toJSON} from "./common/parse/helper/parse";
import * as  axios from "axios";
const UserObj = generateParseObject("v5_user");
const Parse=window.Parse;
const getData = (resp) => resp.data;
const md5=require("blueimp-md5");

export default class Users {
    static addUser(username,showName,isTeacher,studentNumber) {
        return axios.post("/user/reg", {username,password:username,showName,isTeacher,studentNumber}).then(getData);
    }

    static changePassword(username,old_password,new_password){
        return axios.post("/user/change_password", {username,old_password,new_password}).then(getData);
    }

    static resetPassword(username){
        return axios.post("/user/reset_password", {username}).then(getData);
    }

    static checkUserPassword(username,password){
        const salt="lims_v5";
        const password_md5 = md5(password+salt);
        return axios.post("/user/check_password", {username,password_md5}).then(getData)
            .catch(e=>{return {status:false,message:e.response.data.error}});
    }

    static getUsers(isTeacher,isAdmin){
        const query = new Parse.Query(UserObj);
        query.equalTo('isTeacher',isTeacher);
        query.equalTo('isAdmin',isAdmin);
        query.notEqualTo('isDeleted',true);
        query.limit(9999);
        return query.find().then(toJSONList)
    }
    // 获取助教信息
    static getTeacherByUsername(username) {
        const query = new Parse.Query(UserObj);
        query.notEqualTo('isDeleted',true);
        query.equalTo('isTeacher',true);
        query.equalTo('username',username);
        return query.find().then(toJSONList)
    }
    static getTeachers(isTeacher){
        const query = new Parse.Query(UserObj);
        query.equalTo('isTeacher',isTeacher);
        query.notEqualTo('isDeleted',true);
        query.limit(9999);
        query.ascending('showName');
        return query.find().then(toJSONList)
    }

    static fetchUser(username){
        const query = new Parse.Query(UserObj);
        query.equalTo('username',username);
        query.notEqualTo('isDeleted',true);
        return query.first().then(toJSON)
    }

    static getUserById(id){
        return axios.post("/user/get_user_by_id", {id}).then(getData);
        // const query = new Parse.Query(UserObj);
        // query.equalTo('objectId',objectId);
        // query.notEqualTo('isDeleted',true);
        // return query.first().then(toJSON)
    }

    static fetchUserByKey(key,value){
        const query = new Parse.Query(UserObj);
        query.equalTo(key,value);
        query.notEqualTo('isDeleted',true);
        return query.first().then(toJSON)
    }

    static getUsersByUsernames(usernames){
        const query = new Parse.Query(UserObj);
        query.containedIn('username',usernames);
        query.notEqualTo('isDeleted',true);
        query.limit(9999);
        return query.find().then(toJSONList)
    }
    static getUserByUsername(username){
        const query = new Parse.Query(UserObj);
        query.equalTo('username',username);
        query.notEqualTo('isDeleted',true);
        return query.first().then(toJSON)
    }
    static updateUser(key,value,objectId){
        return axios.post("/user/update_one_field", {key,value,objectId}).then(getData);
    }

    static batchUpdateUser(key,value,objectIds){
        return axios.post("/teacher/user/batch_update", {key,value,objectIds}).then(getData);
    }
    // 删除用户
    static removeUser(objectId){
        return axios.post("/teacher/user/remove", {objectId}).then((result) => {
            //console.log("result.status",result.status);
        }).catch(e => {
            //console.log("remove fail",e.toString());
        })
    }

    // 批量更新用户
    static batchUpdateUsers(users) {
        return axios.post('/teacher/user/update_users',{users}).then(getData)
    }

    static getStudentsByPageOnConditions(currentPage,pageSize,sortName,sortOrder,filters){
        const query = new Parse.Query(UserObj);
        query.notEqualTo("isDeleted", true);
        query.notEqualTo('isTeacher',true);
        query.notEqualTo('isAdmin',true);
        query.skip((currentPage-1)*pageSize).limit(pageSize);
        switch (sortOrder) {
            case "descend":
                query.descending(sortName);
                break;
            case "ascend":
                query.ascending(sortName);
                break;
            default:
                break;
        }
        if(filters.showName){
            query.contains("showName", filters.showName[0]);
        }
        if(filters.username){
            query.contains("username", filters.username[0]);
        }
        if(filters.studentNumber){
            query.contains("studentNumber", filters.studentNumber[0]);
        }
        if(filters.cardId){
            query.contains("cardId", filters.cardId[0]);
        }
        return query.find().then(toJSONList);
    }

    static getStudentCount(sortName,sortOrder,filters){
        const query = new Parse.Query(UserObj);
        query.notEqualTo("isDeleted", true);
        query.notEqualTo('isTeacher',true);
        query.notEqualTo('isAdmin',true);
        switch (sortOrder) {
            case "descend":
                query.descending(sortName);
                break;
            case "ascend":
                query.ascending(sortName);
                break;
            default:
                break;
        }
        if(filters.showName){
            query.contains("showName", filters.showName[0]);
        }
        if(filters.username){
            query.contains("username", filters.username[0]);
        }
        if(filters.studentNumber){
            query.contains("studentNumber", filters.studentNumber[0]);
        }
        if(filters.cardId){
            query.contains("cardId", filters.cardId[0]);
        }
        return query.count();
    }

    static getUsersByInfo(info,usernames){
        var queryUsername = new Parse.Query(UserObj);
        queryUsername.contains("username", info);
        var queryShowname = new Parse.Query(UserObj);
        queryShowname.contains("showName", info);
        var queryStudentNumber = new Parse.Query(UserObj);
        queryStudentNumber.contains("studentNumber", info);
        var queryStudentCardId = new Parse.Query(UserObj);
        queryStudentCardId.contains("cardId", info);
        var mainQuery = Parse.Query.or(queryUsername, queryShowname, queryStudentNumber,queryStudentCardId);
        mainQuery.notEqualTo("isDeleted", true);
        mainQuery.notEqualTo('isTeacher',true);
        mainQuery.notEqualTo('isAdmin',true);
        mainQuery.limit(11);
        if(usernames){
            mainQuery.notContainedIn('username',usernames)
        }
        return mainQuery.find().then(toJSONList);
    }

    static getUserByUnionid(unionid){
        const query = new Parse.Query(UserObj);
        query.notEqualTo("isDeleted", true);
        query.equalTo('unionid', unionid);
        return query.first().then(toJSON)
    }

    static async queryUserContainsStr(str) {
        const query = new Parse.Query(UserObj);
        query.notEqualTo('isDeleted', true);
        query.contains("username", str);
        return query.find().then(toJSONList);
    }
}